import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-date-picker';

import CalendarIcon from '@components/icons/calendar.svg';

import CloseIcon from '@components/icons/close.svg';
import StyledDatePicker from './datePicker.style';

const DatePicker = ({ value, onChange, placeholder, ...rest }) => {
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (!value) setClicked(false);
    else setClicked(true);
  }, [value]);

  useEffect(() => {
    document.querySelectorAll('.react-date-picker input').forEach(input => {
      input.style.minWidth = `${input?.getAttribute('placeholder')?.length || 0}ch`;
    });
  }, [clicked]);

  useEffect(() => {
    document.querySelectorAll('.react-date-picker input').forEach(input => {
      input.style.minWidth = `${input?.getAttribute('placeholder')?.length || 0}ch`;
    });
  }, []);

  return (
    <StyledDatePicker>
      <ReactDatePicker
        className={clicked ? 'clicked' : ''}
        onClick={() => setClicked(true)}
        onBlur={() => !value && setClicked(false)}
        onFocus={() => setClicked(true)}
        value={value}
        onChange={onChange}
        calendarIcon={!value ? <CalendarIcon width="20px" height="20px" /> : null}
        clearIcon={value ? <CloseIcon width="15px" height="15px" /> : null}
        dayPlaceholder={!clicked ? placeholder : '--'}
        monthPlaceholder={!clicked ? '' : '--'}
        yearPlaceholder={!clicked ? '' : '----'}
        {...rest}
      />
    </StyledDatePicker>
  );
};

DatePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired
};

export default DatePicker;
